//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const NOTIFICATION_API_BASE_URL = new InjectionToken<string>('NOTIFICATION_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class NotificationFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(NOTIFICATION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param hasUnreadNotifications (optional) 
     * @param recipientTypes (optional) 
     * @param windowBegin (optional) 
     * @param windowEnd (optional) 
     * @return Success
     */
    getNotificationRecipients(companyId: number, pageNumber?: number | undefined, pageSize?: number | undefined, hasUnreadNotifications?: boolean | undefined, recipientTypes?: string | undefined, windowBegin?: Date | undefined, windowEnd?: Date | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/{companyId}/notification-recipients?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (hasUnreadNotifications === null)
            throw new globalThis.Error("The parameter 'hasUnreadNotifications' cannot be null.");
        else if (hasUnreadNotifications !== undefined)
            url_ += "hasUnreadNotifications=" + encodeURIComponent("" + hasUnreadNotifications) + "&";
        if (recipientTypes === null)
            throw new globalThis.Error("The parameter 'recipientTypes' cannot be null.");
        else if (recipientTypes !== undefined)
            url_ += "recipientTypes=" + encodeURIComponent("" + recipientTypes) + "&";
        if (windowBegin === null)
            throw new globalThis.Error("The parameter 'windowBegin' cannot be null.");
        else if (windowBegin !== undefined)
            url_ += "windowBegin=" + encodeURIComponent(windowBegin ? "" + windowBegin.toISOString() : "") + "&";
        if (windowEnd === null)
            throw new globalThis.Error("The parameter 'windowEnd' cannot be null.");
        else if (windowEnd !== undefined)
            url_ += "windowEnd=" + encodeURIComponent(windowEnd ? "" + windowEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetNotificationRecipients(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSystemEventMessageMapping(body?: number[] | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSystemEventMessageMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSystemEventMessageMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processDeleteSystemEventMessageMapping(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByIdEventMessagesMapped(id: number): Observable<EventMessageMappingResponseDto[]> {
        let url_ = this.baseUrl + "/api/Event/{id}/messages";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdEventMessagesMapped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdEventMessagesMapped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventMessageMappingResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventMessageMappingResponseDto[]>;
        }));
    }

    protected processGetByIdEventMessagesMapped(response: HttpResponseBase): Observable<EventMessageMappingResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventMessageMappingResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateEventMessageMapping(body?: EventMessageMappingRequestDto | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Event/messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateEventMessageMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateEventMessageMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processCreateUpdateEventMessageMapping(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConfigByCategory(category: string): Observable<MasterConfigDto[]> {
        let url_ = this.baseUrl + "/api/MasterConfigDdl/{category}";
        if (category === undefined || category === null)
            throw new globalThis.Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterConfigDto[]>;
        }));
    }

    protected processGetConfigByCategory(response: HttpResponseBase): Observable<MasterConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendMockEmail(body?: EncodedMailNotificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MockEmail/sendmockemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMockEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMockEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMockEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendMockSms(body?: SmsMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MockSms/sendmocksms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMockSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMockSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMockSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllNotificationConfigurations(id: number): Observable<NotificationConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/NotificationConfigurationDetails/{id}/fetch";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotificationConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotificationConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationConfigurationDto[]>;
        }));
    }

    protected processGetAllNotificationConfigurations(response: HttpResponseBase): Observable<NotificationConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationConfigurationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateNotificationMessage(body?: NotificationMessagesDto | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/NotificationMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateNotificationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateNotificationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processCreateUpdateNotificationMessage(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteNotificationMessages(body?: NotificationMessagesIdsDto | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/NotificationMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotificationMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotificationMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processDeleteNotificationMessages(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationMessagesById(id: number): Observable<NotificationMessagesDto> {
        let url_ = this.baseUrl + "/api/NotificationMessages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationMessagesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationMessagesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessagesDto>;
        }));
    }

    protected processGetNotificationMessagesById(response: HttpResponseBase): Observable<NotificationMessagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationMessagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllNotificationMessages(body?: CustomFilterRequestV2 | undefined): Observable<NotificationMessagesDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/NotificationMessages/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotificationMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotificationMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessagesDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessagesDtoGridResponseBase>;
        }));
    }

    protected processGetAllNotificationMessages(response: HttpResponseBase): Observable<NotificationMessagesDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationMessagesDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllNotifications(body?: NotificationDto | undefined): Observable<NotificationDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDtoGridResponseBase>;
        }));
    }

    protected processGetAllNotifications(response: HttpResponseBase): Observable<NotificationDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleReadNotification(body?: NotificationDto | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleReadNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleReadNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processToggleReadNotification(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteNotification(body?: NotificationIdsDto | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationById(id: number): Observable<NotificationDto> {
        let url_ = this.baseUrl + "/api/Notifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto>;
        }));
    }

    protected processGetNotificationById(response: HttpResponseBase): Observable<NotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNotificationUnReadCnt(body?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Notifications/unreadcount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationUnReadCnt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationUnReadCnt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNotificationUnReadCnt(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationPlaceholder(systemEventId: number): Observable<NotificationPlaceholderDto[]> {
        let url_ = this.baseUrl + "/api/Placeholder/{systemEventId}";
        if (systemEventId === undefined || systemEventId === null)
            throw new globalThis.Error("The parameter 'systemEventId' must be defined.");
        url_ = url_.replace("{systemEventId}", encodeURIComponent("" + systemEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationPlaceholder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationPlaceholder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationPlaceholderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationPlaceholderDto[]>;
        }));
    }

    protected processGetNotificationPlaceholder(response: HttpResponseBase): Observable<NotificationPlaceholderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationPlaceholderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllSystemEvents(body?: CustomFilterRequestV2 | undefined): Observable<SystemEventTypeDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/SystemEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSystemEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSystemEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemEventTypeDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemEventTypeDtoGridResponseBase>;
        }));
    }

    protected processGetAllSystemEvents(response: HttpResponseBase): Observable<SystemEventTypeDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemEventTypeDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEventMessageStatus(body?: SystemEventTypeDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/SystemEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventMessageStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventMessageStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateEventMessageStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CustomFilterRequestV2 implements ICustomFilterRequestV2 {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filters?: FilterCriterion[] | undefined;
    pageSize?: number;
    pageNumber?: number;
    appendUsername?: boolean;
    searchParameter?: string | undefined;

    constructor(data?: ICustomFilterRequestV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterCriterion.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.appendUsername = _data["appendUsername"];
            this.searchParameter = _data["searchParameter"];
        }
    }

    static fromJS(data: any): CustomFilterRequestV2 {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFilterRequestV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["appendUsername"] = this.appendUsername;
        data["searchParameter"] = this.searchParameter;
        return data;
    }
}

export interface ICustomFilterRequestV2 {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filters?: FilterCriterion[] | undefined;
    pageSize?: number;
    pageNumber?: number;
    appendUsername?: boolean;
    searchParameter?: string | undefined;
}

export class EncodedMailNotificationRequest implements IEncodedMailNotificationRequest {
    encodedData?: string | undefined;

    constructor(data?: IEncodedMailNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encodedData = _data["encodedData"];
        }
    }

    static fromJS(data: any): EncodedMailNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EncodedMailNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encodedData"] = this.encodedData;
        return data;
    }
}

export interface IEncodedMailNotificationRequest {
    encodedData?: string | undefined;
}

export class EventMessageMappingDto implements IEventMessageMappingDto {
    id?: number;
    recipientTypeId?: number;
    notificationMessageId?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    systemEventConfigId?: number | undefined;

    constructor(data?: IEventMessageMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipientTypeId = _data["recipientTypeId"];
            this.notificationMessageId = _data["notificationMessageId"];
            this.expirationDays = _data["expirationDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.systemEventConfigId = _data["systemEventConfigId"];
        }
    }

    static fromJS(data: any): EventMessageMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventMessageMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientTypeId"] = this.recipientTypeId;
        data["notificationMessageId"] = this.notificationMessageId;
        data["expirationDays"] = this.expirationDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["systemEventConfigId"] = this.systemEventConfigId;
        return data;
    }
}

export interface IEventMessageMappingDto {
    id?: number;
    recipientTypeId?: number;
    notificationMessageId?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    systemEventConfigId?: number | undefined;
}

export class EventMessageMappingRequestDto implements IEventMessageMappingRequestDto {
    systemEventId?: number;
    eventMessagesMapped?: EventMessageMappingDto;

    constructor(data?: IEventMessageMappingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventId = _data["systemEventId"];
            this.eventMessagesMapped = _data["eventMessagesMapped"] ? EventMessageMappingDto.fromJS(_data["eventMessagesMapped"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventMessageMappingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventMessageMappingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventId"] = this.systemEventId;
        data["eventMessagesMapped"] = this.eventMessagesMapped ? this.eventMessagesMapped.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventMessageMappingRequestDto {
    systemEventId?: number;
    eventMessagesMapped?: EventMessageMappingDto;
}

export class EventMessageMappingResponseDto implements IEventMessageMappingResponseDto {
    id?: number;
    systemEventConfigId?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    recipientType?: RecipientTypeDto;
    notificationMessage?: NotificationMessageDetailsDto;
    configuration?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IEventMessageMappingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemEventConfigId = _data["systemEventConfigId"];
            this.expirationDays = _data["expirationDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.recipientType = _data["recipientType"] ? RecipientTypeDto.fromJS(_data["recipientType"]) : undefined as any;
            this.notificationMessage = _data["notificationMessage"] ? NotificationMessageDetailsDto.fromJS(_data["notificationMessage"]) : undefined as any;
            this.configuration = _data["configuration"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): EventMessageMappingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventMessageMappingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemEventConfigId"] = this.systemEventConfigId;
        data["expirationDays"] = this.expirationDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["recipientType"] = this.recipientType ? this.recipientType.toJSON() : undefined as any;
        data["notificationMessage"] = this.notificationMessage ? this.notificationMessage.toJSON() : undefined as any;
        data["configuration"] = this.configuration;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IEventMessageMappingResponseDto {
    id?: number;
    systemEventConfigId?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    recipientType?: RecipientTypeDto;
    notificationMessage?: NotificationMessageDetailsDto;
    configuration?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class FilterCriterion implements IFilterCriterion {
    field!: string;
    op!: string;
    value!: any;

    constructor(data?: IFilterCriterion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.op = _data["op"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterCriterion {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriterion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["op"] = this.op;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilterCriterion {
    field: string;
    op: string;
    value: any;
}

export class MasterConfigDto implements IMasterConfigDto {
    id?: number;
    code?: string | undefined;
    displayText?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;

    constructor(data?: IMasterConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.description = _data["description"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): MasterConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["description"] = this.description;
        data["category"] = this.category;
        return data;
    }
}

export interface IMasterConfigDto {
    id?: number;
    code?: string | undefined;
    displayText?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
}

export class NotificationConfigurationDto implements INotificationConfigurationDto {
    systemEventConfigId?: number;
    configuration?: string | undefined;
    isCaregiverCentric?: boolean;
    isDisabled?: boolean;

    constructor(data?: INotificationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventConfigId = _data["systemEventConfigId"];
            this.configuration = _data["configuration"];
            this.isCaregiverCentric = _data["isCaregiverCentric"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): NotificationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventConfigId"] = this.systemEventConfigId;
        data["configuration"] = this.configuration;
        data["isCaregiverCentric"] = this.isCaregiverCentric;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface INotificationConfigurationDto {
    systemEventConfigId?: number;
    configuration?: string | undefined;
    isCaregiverCentric?: boolean;
    isDisabled?: boolean;
}

export class NotificationDto implements INotificationDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;
    notificationId?: number;
    recipientId?: string | undefined;
    notificationDate?: Date;
    priority?: number;
    isRead?: boolean;
    notificationMessage?: string | undefined;
    regardingId?: string | undefined;
    regardingName?: string | undefined;
    userMail?: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.appendUsername = _data["appendUsername"];
            this.notificationId = _data["notificationId"];
            this.recipientId = _data["recipientId"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.isRead = _data["isRead"];
            this.notificationMessage = _data["notificationMessage"];
            this.regardingId = _data["regardingId"];
            this.regardingName = _data["regardingName"];
            this.userMail = _data["userMail"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["appendUsername"] = this.appendUsername;
        data["notificationId"] = this.notificationId;
        data["recipientId"] = this.recipientId;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined as any;
        data["priority"] = this.priority;
        data["isRead"] = this.isRead;
        data["notificationMessage"] = this.notificationMessage;
        data["regardingId"] = this.regardingId;
        data["regardingName"] = this.regardingName;
        data["userMail"] = this.userMail;
        return data;
    }
}

export interface INotificationDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;
    notificationId?: number;
    recipientId?: string | undefined;
    notificationDate?: Date;
    priority?: number;
    isRead?: boolean;
    notificationMessage?: string | undefined;
    regardingId?: string | undefined;
    regardingName?: string | undefined;
    userMail?: string | undefined;
}

export class NotificationDtoGridResponseBase implements INotificationDtoGridResponseBase {
    items?: NotificationDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: NotificationDto;

    constructor(data?: INotificationDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? NotificationDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface INotificationDtoGridResponseBase {
    items?: NotificationDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: NotificationDto;
}

export class NotificationIdsDto implements INotificationIdsDto {
    ids?: number[] | undefined;
    userMail?: string | undefined;
    recipientId?: string | undefined;

    constructor(data?: INotificationIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.userMail = _data["userMail"];
            this.recipientId = _data["recipientId"];
        }
    }

    static fromJS(data: any): NotificationIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["userMail"] = this.userMail;
        data["recipientId"] = this.recipientId;
        return data;
    }
}

export interface INotificationIdsDto {
    ids?: number[] | undefined;
    userMail?: string | undefined;
    recipientId?: string | undefined;
}

export class NotificationMessageDetailsDto implements INotificationMessageDetailsDto {
    systemEventId?: number;
    notificationMessageId?: number;
    notificationName?: string | undefined;
    notificationType?: string | undefined;
    message?: string | undefined;
    priority?: number;

    constructor(data?: INotificationMessageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventId = _data["systemEventId"];
            this.notificationMessageId = _data["notificationMessageId"];
            this.notificationName = _data["notificationName"];
            this.notificationType = _data["notificationType"];
            this.message = _data["message"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): NotificationMessageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventId"] = this.systemEventId;
        data["notificationMessageId"] = this.notificationMessageId;
        data["notificationName"] = this.notificationName;
        data["notificationType"] = this.notificationType;
        data["message"] = this.message;
        data["priority"] = this.priority;
        return data;
    }
}

export interface INotificationMessageDetailsDto {
    systemEventId?: number;
    notificationMessageId?: number;
    notificationName?: string | undefined;
    notificationType?: string | undefined;
    message?: string | undefined;
    priority?: number;
}

export class NotificationMessagesDto implements INotificationMessagesDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;
    notificationMessageId?: number;
    systemEventId?: number | undefined;
    notification?: string | undefined;
    notificationType?: string | undefined;
    priority?: number;
    message?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: INotificationMessagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.appendUsername = _data["appendUsername"];
            this.notificationMessageId = _data["notificationMessageId"];
            this.systemEventId = _data["systemEventId"];
            this.notification = _data["notification"];
            this.notificationType = _data["notificationType"];
            this.priority = _data["priority"];
            this.message = _data["message"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationMessagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["appendUsername"] = this.appendUsername;
        data["notificationMessageId"] = this.notificationMessageId;
        data["systemEventId"] = this.systemEventId;
        data["notification"] = this.notification;
        data["notificationType"] = this.notificationType;
        data["priority"] = this.priority;
        data["message"] = this.message;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface INotificationMessagesDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;
    notificationMessageId?: number;
    systemEventId?: number | undefined;
    notification?: string | undefined;
    notificationType?: string | undefined;
    priority?: number;
    message?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class NotificationMessagesDtoGridResponseBase implements INotificationMessagesDtoGridResponseBase {
    items?: NotificationMessagesDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: NotificationMessagesDto;

    constructor(data?: INotificationMessagesDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationMessagesDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? NotificationMessagesDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationMessagesDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessagesDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface INotificationMessagesDtoGridResponseBase {
    items?: NotificationMessagesDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: NotificationMessagesDto;
}

export class NotificationMessagesIdsDto implements INotificationMessagesIdsDto {
    ids?: number[] | undefined;

    constructor(data?: INotificationMessagesIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationMessagesIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessagesIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface INotificationMessagesIdsDto {
    ids?: number[] | undefined;
}

export class NotificationPlaceholderDto implements INotificationPlaceholderDto {
    propertyName?: string | undefined;
    propertyType?: string | undefined;

    constructor(data?: INotificationPlaceholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyType = _data["propertyType"];
        }
    }

    static fromJS(data: any): NotificationPlaceholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationPlaceholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyType"] = this.propertyType;
        return data;
    }
}

export interface INotificationPlaceholderDto {
    propertyName?: string | undefined;
    propertyType?: string | undefined;
}

export class RecipientTypeDto implements IRecipientTypeDto {
    recipientTypeId?: number;
    recipientTypeCode?: string | undefined;
    recipientTypeText?: string | undefined;

    constructor(data?: IRecipientTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientTypeId = _data["recipientTypeId"];
            this.recipientTypeCode = _data["recipientTypeCode"];
            this.recipientTypeText = _data["recipientTypeText"];
        }
    }

    static fromJS(data: any): RecipientTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientTypeId"] = this.recipientTypeId;
        data["recipientTypeCode"] = this.recipientTypeCode;
        data["recipientTypeText"] = this.recipientTypeText;
        return data;
    }
}

export interface IRecipientTypeDto {
    recipientTypeId?: number;
    recipientTypeCode?: string | undefined;
    recipientTypeText?: string | undefined;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;
}

export class SmsMessage implements ISmsMessage {
    from?: string | undefined;
    to?: string | undefined;
    body?: string | undefined;
    attachmentUrl?: string | undefined;

    constructor(data?: ISmsMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.body = _data["body"];
            this.attachmentUrl = _data["attachmentUrl"];
        }
    }

    static fromJS(data: any): SmsMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SmsMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["body"] = this.body;
        data["attachmentUrl"] = this.attachmentUrl;
        return data;
    }
}

export interface ISmsMessage {
    from?: string | undefined;
    to?: string | undefined;
    body?: string | undefined;
    attachmentUrl?: string | undefined;
}

export class StringApiResponse implements IStringApiResponse {
    message?: string | undefined;
    data?: string | undefined;
    success?: boolean;

    constructor(data?: IStringApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): StringApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        data["success"] = this.success;
        return data;
    }
}

export interface IStringApiResponse {
    message?: string | undefined;
    data?: string | undefined;
    success?: boolean;
}

export class SystemEventTypeDto implements ISystemEventTypeDto {
    systemEventId?: number;
    systemEvent?: string | undefined;
    eventType?: number;
    systemControl?: string | undefined;
    isCaregiverCentric?: boolean;
    code?: string | undefined;
    displayText?: string | undefined;
    isDisabled?: boolean;
    isActive?: boolean;

    constructor(data?: ISystemEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventId = _data["systemEventId"];
            this.systemEvent = _data["systemEvent"];
            this.eventType = _data["eventType"];
            this.systemControl = _data["systemControl"];
            this.isCaregiverCentric = _data["isCaregiverCentric"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.isDisabled = _data["isDisabled"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SystemEventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventId"] = this.systemEventId;
        data["systemEvent"] = this.systemEvent;
        data["eventType"] = this.eventType;
        data["systemControl"] = this.systemControl;
        data["isCaregiverCentric"] = this.isCaregiverCentric;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["isDisabled"] = this.isDisabled;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISystemEventTypeDto {
    systemEventId?: number;
    systemEvent?: string | undefined;
    eventType?: number;
    systemControl?: string | undefined;
    isCaregiverCentric?: boolean;
    code?: string | undefined;
    displayText?: string | undefined;
    isDisabled?: boolean;
    isActive?: boolean;
}

export class SystemEventTypeDtoGridResponseBase implements ISystemEventTypeDtoGridResponseBase {
    items?: SystemEventTypeDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: SystemEventTypeDto;

    constructor(data?: ISystemEventTypeDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SystemEventTypeDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? SystemEventTypeDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): SystemEventTypeDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEventTypeDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ISystemEventTypeDtoGridResponseBase {
    items?: SystemEventTypeDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: SystemEventTypeDto;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}